import { getNamedType, isScalarType, isEnumType, isInputObjectType } from "graphql";
function typeCategory(type) {
  const named = getNamedType(type);
  if (isScalarType(named)) {
    return "scalar";
  }
  if (isEnumType(named)) {
    return "enum";
  }
  if (isInputObjectType(named)) {
    return "input";
  }
  return "composite";
}
export {
  typeCategory
};
//# sourceMappingURL=type-category.js.map
